import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { color, spacing } from '@lightspeed/cirrus-tokens/utils';
import { SidebarItem } from '@lightspeed/cirrus-sidebar';
import { COLOR_SIDEBAR_ITEM_ACTIVE } from '@lightspeed/cirrus-sidebar/dist/styles/constants';

const sidebarLockActiveStyles = css`
  border: 1px solid ${COLOR_SIDEBAR_ITEM_ACTIVE};
`;

// eslint-disable-next-line import/prefer-default-export
export const LockButton = styled(SidebarItem)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid ${color('seal-200')};
  margin-top: ${spacing(2)};
  margin-bottom: ${spacing(2)};
  height: ${spacing(8)};
  cursor: pointer;

  figure {
    padding-left: 0;
  }

  ${props => props.active && sidebarLockActiveStyles} &:active {
    ${sidebarLockActiveStyles};
  }
`;
